import React, {Component} from 'react'
import {fieldsToHtml, getProp} from "../../util/util";
import RatingScales from "../../components/survey-builder/question-types/rating-scales";
import LikertScales from "../../components/survey-builder/question-types/likert-scales";
import QuestionMatrix from "../../components/survey-builder/question-types/question-matrix";
import QuestionDropdown from "../../components/survey-builder/question-types/dropdown";
import QuestionRanking from "../../components/survey-builder/question-types/question-ranking";
import FieldTextarea from "../../components/field-textarea";
import FieldText from "../../components/field-text";
import InformationCircleIcon from "@heroicons/react/outline/InformationCircleIcon";
import Loader from "../../components/loader";
import {createDialogResource} from "../../data/actions/dialogResource";
import LocalStorage from "../../util/localStorage";
import Resources from "../../data/services/resources";
import {Field} from "../../data/services/fields";

export default class ExtCandidateRoleSurvey extends Component {

    constructor(props) {
        super(props);

        this.state = {
            surveyFields: {},
            questionItems: {},
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.dialogResource.isLoading && !this.props.dialogResource.isLoading && !!this.props.dialogResource?.data?.survey) {
            let questionItems = getProp(this.props, "dialogResource.data.survey", {}).reduce((memo, it, i) => {
                const orderNumber = it.RoleSurveyID;

                if (it.Items.length) {
                    memo[orderNumber] = it.Items

                    if (it.Answer && it.ShortSurveyTypeID == 5) {
                        const items = it.Items.reduce((memo, it) => {memo[it.RoleSurveyItemID] = it; return memo}, {});

                        const userAnswers = it.Answer.split(",");

                        // Ignore if questions are added or removed
                        if (userAnswers.length === it.Items.length) {
                            memo[orderNumber] = userAnswers.map(it => {
                                let itemID = it.split('-')[0]
                                return items[itemID]
                            });
                        }
                    }
                }

                return memo
            }, {});

            this.setState({
                surveyFields: getProp(this.props, "dialogResource.data.survey", []).reduce((memo, it) => {

                    memo[it.RoleSurveyID] = it.Answer;

                    // Ranking
                    if (it.ShortSurveyTypeID == 5) {
                        const items = it.Items.reduce((memo, it) => {memo[it.RoleSurveyItemID] = it; return memo}, {});

                        memo[it.RoleSurveyID] = it.Answer.split(",").map(it => {
                            let itemID = it.split('-')[0]
                            return items[itemID]
                        });
                    }

                    // Matrix
                    if (it.ShortSurveyTypeID == 3) {
                        memo[it.RoleSurveyID] = it.Answer.split(",").reduce((memo, it, i) => {
                            let index = i+1;
                            let value = it.split('-')[1]
                            switch (value) {
                                case "1":
                                    memo[index] = "very_satisfied"
                                    break;
                                case "2":
                                    memo[index] = "satisfied"
                                    break;
                                case "3":
                                    memo[index] = "neither"
                                    break;
                                case "4":
                                    memo[index] = "dissatisfied";
                                    break;
                                case "5":
                                    memo[index] = "very_satisfied";
                                    break;
                                default:
                                    return  memo[i] = "";
                            }
                            return memo
                        }, {})
                    }

                    return memo;
                }, {}),
                questionItems: questionItems
            })
        }
    }

    handleSurveyAnswerChange = (survey, answer) => {
        let surveyFields = this.state.surveyFields;
        surveyFields[survey] = answer;
        this.setState({
            surveyFields: surveyFields
        })
    }

    submitSurveyAnswers = () => {
        const surveyFields = this.state.surveyFields;
        this.setState({
            selectedForInterview: null,
            questionsFields: {},
            surveyFields: {}
        }, () => {
            const allQuestionTypes = Object.values(getProp(this.props, "dialogResource.data.survey", {})).reduce((memo, it) => { memo[it.RoleSurveyID] = it.ShortSurveyTypeID; return memo}, {});

            this.props.dispatch(createDialogResource({
                user: LocalStorage.get("user"),
                query: this.props.getQuery(),
                params: {
                    // id: this.getId(),
                    Answers: Object.keys(surveyFields).filter(key => !(allQuestionTypes[key] == 4 && !surveyFields[key])).map((key) => {
                        let answer = surveyFields[key];

                        if (allQuestionTypes[key] == 3) {
                            answer = this.formatMatrixQuestionsForSubmit(surveyFields[key], key);
                        }

                        // Ranking questions
                        if (allQuestionTypes[key] == 5 && !!answer.length) {
                            // Get default (randomized) order if user didn't made any ranking changes
                            if (answer[0] == undefined) {
                                this.state.questionItems[key].map(it => it.RoleSurveyItemID).join(",");
                            } else {
                                answer = answer.map(it => it.RoleSurveyItemID).join(",")
                            }
                        }

                        return {
                            RoleSurveyID: key,
                            CandidateAnswer: answer
                        }
                    }),
                    RoleID: this.props.role.RoleID
                },
                resource: Resources.ExtCandidateRolesSurvey,
                piggyResource: Resources.ExtRoles,
                notificationMessage: "You have submitted survey answers " + this.props.role.RoleName,
            }));

            this.props.onClose({});
        })
    };

    handleDragStart = (i) => {
        this.setState({itemIndexDragged : i})
    }

    handleDragEnter = (i, questionNum, RoleSurveyID) => {
        let questionItems = this.state.questionItems;
        let rowOrder = JSON.parse(JSON.stringify(questionItems[questionNum]));

        [rowOrder[this.state.itemIndexDragged], rowOrder[i]] = [rowOrder[i], rowOrder[this.state.itemIndexDragged]];

        questionItems[questionNum] = rowOrder;

        this.setState({
            questionItems: questionItems,
            itemIndexDragged: i,
        }, () => {
            this.handleSurveyAnswerChange(RoleSurveyID, rowOrder)
        })
    }

    handleDragEnd = () => {

    }

    handleDragLeave = () => {

    }

    handleDrop = () => {
        this.setState({itemIndexDragged : -1})
    }

    formatMatrixQuestionsForSubmit = (itemValue, questionID) => {
        let formatedValue = [];
        for (const [key, value] of Object.entries(itemValue)) {
            const RoleSurveyItemID = this.state.questionItems[questionID][key - 1].RoleSurveyItemID
            switch (value) {
                case "very_satisfied":
                    formatedValue.push(RoleSurveyItemID + "-1");
                    break;
                case "satisfied":
                    formatedValue.push(RoleSurveyItemID + "-2");
                    break;
                case "neither":
                    formatedValue.push(RoleSurveyItemID + "-3");
                    break;
                case "dissatisfied":
                    formatedValue.push(RoleSurveyItemID + "-4");
                    break;
                case "very_dissatisfied":
                    formatedValue.push(RoleSurveyItemID + "-5");
                    break;
                default:
                    formatedValue.push(RoleSurveyItemID + "-0")
            }
        }
        return formatedValue.join(",");
    }

    /** Render
     ================================================================= */
    render() {
        const {translate} = this.props;

        // Move constants to util
        const questionMatrixID = 3;
        const ratingScalesID = 1;
        const likertScalesID = 2;
        const dropDownID = 4;
        const rankingQuestionsID = 5;
        const textQuestionID = 6;
        const numberQuestionID = 7;

        const isLoading = getProp(this.props, "dialogResource.isLoading", false);

        const survey = getProp(this.props, "dialogResource.data.survey", []);

        const surveyFields = survey.map((it, i) => {
            let dropdownValues = {};
            if (it.ShortSurveyTypeID == dropDownID) {
                dropdownValues = it.Items.reduce((memo, it, i) => {
                    memo[it.RoleSurveyItemID] = it.RoleSurveyItemName;
                    return memo
                }, {});
            }

            let field = "";
            let disc = "";
            switch (it.ShortSurveyTypeID) {
                case 1:
                case ratingScalesID:
                    field = (
                        <RatingScales
                            onClick={(name, value) => {
                                this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                            }}
                            value={this.state.surveyFields[it.RoleSurveyID] ?? ""}
                            topRating={10}
                        />
                    );
                    disc = (<p className="mb-1 text-sm text-secondary-500">* Enter text as an answer.</p>);
                    break;
                case 2:
                case likertScalesID:
                    field = (
                        <LikertScales
                            name={"question-" + it.RoleSurveyID}
                            onChange={(name, value) => {
                                this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                            }}
                            value={this.state.surveyFields[it.RoleSurveyID]}
                        />
                    );
                    disc = (<p className="mb-1 text-sm text-secondary-500">* Enter number as an answer.</p>);
                    break;
                case 3:
                case questionMatrixID:
                {this.state.questionItems[it.RoleSurveyID] && (
                    field = (
                        <QuestionMatrix
                            index={i}
                            name={"question-" + it.RoleSurveyID}
                            matrixQuestions={this.state.questionItems[it.RoleSurveyID]}
                            translate={translate}
                            onChange={(name, value) => {
                                this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                            }}
                            value={this.state.surveyFields[it.RoleSurveyID]}
                        />
                    )
                )}
                    break;
                case 4:
                case dropDownID:
                    field = (
                        <div className={"w-3"}>
                            <QuestionDropdown
                                value={this.state.surveyFields[it.RoleSurveyID]}
                                onChange={(name, value) => {
                                    this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                                }}
                                name={"question-" + it.RoleSurveyID}
                                values={dropdownValues}
                            />
                        </div>
                    );
                    disc = (<p className="mb-1 text-sm text-secondary-500">* Mark checkbox for yes answer.</p>);
                    break;
                case 5:
                case rankingQuestionsID:
                {!!this.state.questionItems[it.RoleSurveyID]?.length && (
                    field = (
                        <QuestionRanking
                            translate={translate}
                            questionID={it.RoleSurveyID}
                            rankingOptions={this.state.questionItems[it.RoleSurveyID]}
                            itemIndexDragged={this.state.itemIndexDragged}
                            onDragStart={this.handleDragStart}
                            onDragEnter={(i, questionNum) => this.handleDragEnter(i, questionNum, it.RoleSurveyID)}
                            onDragEnd={this.handleDragStart}
                            onDragLeave={this.handleDragLeave}
                            onDrop={this.handleDragLeave}
                        />
                    )
                )}
                    break;
                case 6:
                case textQuestionID:
                    field = (
                        <FieldTextarea
                            className="form-control w-full"
                            name={"question-" + it.RoleSurveyID}
                            value={this.state.surveyFields[it.RoleSurveyID]}
                            placeholder={this.props.translate("placeholder.enter_answer")}
                            onChange={(name, value) => {
                                this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                            }}
                        />
                    )
                    break;
                case 7:
                case numberQuestionID:
                    field = (
                        <FieldText
                            className="form-control w-48"
                            name={"question-" + it.RoleSurveyID}
                            value={this.state.surveyFields[it.RoleSurveyID]}
                            placeholder={this.props.translate("placeholder.enter_number")}
                            onChange={(name, value) => {
                                this.handleSurveyAnswerChange(it.RoleSurveyID, value)
                            }}
                        />
                    )
                    break;
                default:
                    field = <div/>
            }
            return (
                <>
                    <div key={it.ShortSurveyQuestion} className="flex flex-col justify-center p-4 border-t ">
                        <div className={"flex justify-between items-center px-4 pb-4 mb-4 border-b border-dashed"}>
                            <div>
                                <p className="m-0">
                                    <span>{i + 1}. </span>
                                    <span className="text-lg text-secondary-800">{it.ShortSurveyQuestion}</span>
                                </p>
                            </div>

                            <div>

                            </div>
                        </div>

                        {field}

                        {!!it.Instructions && (
                            <div className="rounded-md bg-secondary-50 p-4 mt-6">
                                <div className="flex">
                                    <div className="flex-shrink-0">
                                        <InformationCircleIcon
                                            className="h-5 w-5 text-secondary-400"
                                            aria-hidden="true"
                                        />
                                    </div>

                                    <div className="ml-3 flex-1 md:flex md:justify-between">
                                        <p className="text-sm text-secondary-700">{it.Instructions}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
            )
        });

        return (
            <div className="">
                {isLoading && (
                    <div className={"inset-center"}>
                        <Loader/>
                    </div>
                )}

                {!isLoading && (
                    <div className="pb-6">
                        <div className="flex flex-col mt-2">
                            <p className="mb-4">Please submit your survey answers, it will help recruiter with your application to the role.</p>

                            <section className="mb-8">
                                <div className="bg-white shadow sm:rounded-md">
                                    <div
                                        className="px-4 py-1 sm:px-6 bg-secondary-100 flex justify-between items-center">
                                        <h2 className="text-lg leading-6 font-medium text-gray-900">
                                            <span className="text-secondary-600">Survey questions</span>
                                        </h2>
                                    </div>

                                    {surveyFields}
                                </div>
                            </section>
                        </div>

                        <button type="button"
                                className="btn btn-outline focus:ring-offset-inverse"
                                onClick={this.props.onClose}
                        >
                            Cancel
                        </button>

                        <button
                            type="submit"
                            className="btn btn-primary ml-3 focus:ring-offset-inverse"
                            onClick={this.submitSurveyAnswers}
                        >
                            Save
                        </button>
                    </div>
                )}
            </div>
        )
    }
}